var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg264WarningBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 54,
    viewBox: "0 0 61 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.3182 46.1667L34.9253 2.83333C33.9491 1.16667 32.2348 0.333333 30.5205 0.333333C28.8063 0.333333 27.092 1.16667 26.0086 2.83333L0.627689 46.1667C-1.21636 49.4881 1.21709 53.6667 5.13245 53.6667H55.9182C59.8182 53.6667 62.2586 49.5 60.3182 46.1667ZM6.30388 47.9524L30.4134 6.61905L54.7348 47.9524H6.30388ZM30.5205 36.6548C28.4539 36.6548 26.7777 38.331 26.7777 40.3976C26.7777 42.4643 28.4575 44.1405 30.5253 44.1405C32.5932 44.1405 34.2634 42.4643 34.2634 40.3976C34.2586 38.3333 32.592 36.6548 30.5205 36.6548ZM27.6634 18.4286V29.8571C27.6634 31.4405 28.9491 32.7143 30.5205 32.7143C32.092 32.7143 33.3777 31.4345 33.3777 29.8571V18.4286C33.3777 16.8571 32.1039 15.5714 30.5205 15.5714C28.9372 15.5714 27.6634 16.8571 27.6634 18.4286Z",
    fill: "#6CB6E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg264WarningBlue);
export default __webpack_public_path__ + "static/media/264-warning-blue.cf2094082e67234968aed7b9a0a88c61.svg";
export { ForwardRef as ReactComponent };